// getIsPrivateShowEarlyBirdTicket.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getGoalData from '../selector/getGoalData.js';
import { livestreamTicketType } from '../resource/liveStreamConstants.js';

/**
 * Select is private show early bird ticket by product id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} productId - product id.
 * @param {string} fundingId - funding goal id.
 * @return {boolean|undefined} Return true if product is private show early bird ticket.
 */
const getIsPrivateShowEarlyBirdTicket = createCachedSelector(
  (state, productId) => productId,
  (state, productId, fundingId) =>
    getGoalData(state, [fundingId, 'context'], 'ticket_product_id'),
  (state, productId, fundingId) =>
    getGoalData(state, [fundingId, 'context'], 'ticket_product_type'),
  (productId, contextProductId, contextProductType) => {
    if (!contextProductId) {
      return;
    }
    return (
      contextProductId === productId &&
      contextProductType === livestreamTicketType.EARLY_BIRD
    );
  }
)((state, productId, fundingId) => `${productId}:${fundingId}`);

export default getIsPrivateShowEarlyBirdTicket;
